import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {UpdateWorkOrderResult} from "../types/UpdateWorkOrderResult";

export const useSubmitWOC = (
	workOrderID: number,
	onSuccess: (result: UpdateWorkOrderResult) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("work-order/submit-woc",
				{
					workOrderID: workOrderID
				}) as UpdateWorkOrderResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when submitting: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
